import LegacyInput from 'src/legacy/Components/Forms/Input';
import { toMoney } from 'src/legacy/Utils/Conversor';

import { PutSellBuyResponse } from 'src/types/api';
import { BuyInstallment } from 'src/types/dto';
import { useCheckoutFormValuesStore } from '../../stores';

const getInstallmentsOptions = (installments: BuyInstallment[] | undefined) => {
  return installments?.map(installment => ({
    value: JSON.stringify(installment),
    option: `${installment.installment} x de ${toMoney(
      installment.value,
    )} (total: ${toMoney(installment.total)})`,
  }));
};

type Props = {
  isLoading: boolean;
  data: PutSellBuyResponse | undefined;
  onChange: (installment: BuyInstallment) => void;
};
export const InstallmentsField = ({ isLoading, data, onChange: _onChange }: Props) => {
  const { formValues, setFormValues } = useCheckoutFormValuesStore();

  const onChange = (installment: string) => {
    const parsed: BuyInstallment = JSON.parse(installment);

    setFormValues({
      installments: parsed.installment,
    });

    if (_onChange instanceof Function) {
      _onChange(parsed);
    }
  };

  if (isLoading || data?.installments?.length === 0) {
    return null;
  }

  const options = getInstallmentsOptions(data?.installments);
  const value = data?.installments?.find(
    installment => installment.installment === formValues.installments,
  );

  return (
    // @ts-ignore
    <LegacyInput
      style={{ color: 'black' }}
      type="select"
      value={JSON.stringify(value)}
      {...{ options, onChange }}
    />
  );
};
